//const ExifImage = require('exif').ExifImage;
// import exif from 'exif-js';
import * as Exifr from 'exifr';
import http from '../http.js';
import config from '../config.js';
import resource from "../../model/resource.js";

var backupPano;
var oldPanoId;

const PI = Math.PI;

//获取图片GPS信息
function getExif(file, callback){
	Exifr.parse(file, {xmp:true}).then(exif => {
		
		if(!exif) exif = {}
		
		const lon = exif.GPSLongitude;
		const lat = exif.GPSLatitude;
		const alt = exif.AbsoluteAltitude || exif.GPSAltitude;
		
		const rx = exif.GimbalPitchDegree ? exif.GimbalPitchDegree : 0;
		const ry = exif.GimbalYawDegree ? exif.GimbalYawDegree : 0;
		const rz = exif.GimbalRollDegree ? exif.GimbalRollDegree : 0;
		
		callback && callback({
			gps     : {
				lon : lon ? (Number(lon[0]) + Number(lon[1]/60) + Number(lon[2]/3600)) : 0,
				lat : lat ? (Number(lat[0]) + Number(lat[1]/60) + Number(lat[2]/3600)) : 0,
				alt : alt ? Number(alt) : 100,
			},
			
			alt	: {
				absolute : exif.AbsoluteAltitude,
				relative : exif.RelativeAltitude,
			},
			
			// rotate	: {
			// 	x : -exif.FlightPitchDegree,
			// 	y : -exif.FlightYawDegree,
			// 	z : -exif.FlightRollDegree,
			// }
			
			rotate	: {
				x : -rx,
				y : -ry,
				z : -rz,
			}
		});
	}).catch(error => {
	  console.error(error);
	});
	
}

//经纬度转化为平面坐标
function latLng2WebMercator(lng, lat) {
    var earthRad = 6378137.0;
    var x = lng * Math.PI / 180 * earthRad;
    var a = lat * Math.PI / 180;
    var y = -earthRad / 2 * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)));
    return {x, y};
}

//DeepSeek推荐
//计算两个坐标的相对偏移（因为直接用墨卡托投影的坐标相减会有误差）
function calculateCoordinates(p1, p2) {
    const EARTH_RADIUS = 6378137.0; // WGS84 equatorial radius in meters
    const lat1 = p1.lat * PI / 180;
    const lon1 = p1.lon * PI / 180;
    const lat2 = p2.lat * PI / 180;
    const lon2 = p2.lon * PI / 180;
    
    const latDifference = lat2 - lat1;
    const lonDifference = lon2 - lon1;
    
    // Use average latitude to calculate east-west distance
    const avgLat = (lat1 + lat2) / 2;
    const dx = EARTH_RADIUS * lonDifference * Math.cos(avgLat);
    const dy = EARTH_RADIUS * latDifference;
    
    // Return {x: east-west distance (meters), y: north-south distance (meters, negative for screen coordinates)}
    return { x: dx, y: -dy };
}

//根据经纬度获取高程数据
function getHeightFromGPS(lng, lat, success){
	http.request({
		url		: 'srtm/elevation30?lng='+lng+'&lat='+lat,
		success,
	})
}

//根据GPS信息生成offset位置
function setOffsetFromGPS(item, data, other){
	let panos	= config.data.panos.filter((item,index,arr)=>{
		return item.gps!=undefined;
	});
	
	let pos		= latLng2WebMercator(item.gps.lon, item.gps.lat);
	let origin	= null;
	let origin_gps = null;
	let alt		= 0;
	item.offset.x = pos.x;
	item.offset.z = pos.y;
	
	if(other !== false){
		
		//重新计算所有的点位offset
		for(let i=0; i<panos.length; i++){
			let pano = panos[i];
			
			if(pano.gps){
				// if(!origin){
				// 	origin	= latLng2WebMercator(pano.gps.lon, pano.gps.lat);
				// }
				// let offset = latLng2WebMercator(pano.gps.lon, pano.gps.lat);
				// pano.offset.x = offset.x - origin.x;
				// pano.offset.z = offset.y - origin.y;
				
				if(!origin_gps) origin_gps = pano.gps;
				
				let offset = calculateCoordinates(origin_gps, pano.gps);
				pano.offset.x = offset.x;
				pano.offset.z = offset.y;
			}
		}
		
	}
	
	//if(data.rotate.x != undefined) item.rotate.x = data.rotate.x;
	if(data && data.rotate && data.rotate.y != undefined) item.rotate.y = data.rotate.y;
	//if(data.rotate.z != undefined) item.rotate.z = data.rotate.z;
	
	if(item.gps.lon && item.gps.lat){
		// if(data.alt.relative != undefined){
		// 	item.offset.y = Number(data.alt.relative);
		// 	if(item.offset.y < 20) item.offset.y = 20;
		// } else {
			getHeightFromGPS(item.gps.lon, item.gps.lat, e=>{
				if(item.gps.alt!=Infinity && item.gps.alt!=undefined && item.gps.alt!=0){
					item.offset.y = Number((item.gps.alt - e).toFixed(2));
					if(item.offset.y < 10) item.offset.y = 10;
				} else {
					item.gps.alt	= e + 100;
					item.offset.y 	= 100;
				}
			});
		// }
	}
}

//检查文件是否合法
function checkFiles(list, success){
	let files 		= list.tempFiles;
	let idx 		= 0;
	let errFiles 	= [];
	let panos		= config.data.panos;
	let setting		= config.data.setting ? config.data.setting.panos : dyEditor.member.pano;
	let max 		= setting - panos.length;

	// return success && success(files);
	
	for(let i in files)
	{
		let file = files[i];
		
		switch(file.type){
			case 'video/mp4':
				if(file.size > 500 * 1024 * 1024){
					file.err = true;
					errFiles.push({
						name: file.name,
						text: '全景图超出500MB的最大限制，无法上传',
					});
				} else if(i>=max){
					file.err = true;
					errFiles.push({
						name: file.name,
						text: '超出最大数量上限，无法上传',
					});
				}
				
				//检查完成
				if(idx++ >= files.length -1) {
					files = files.filter(item => {
						return !item.err;
					});
									
					if(errFiles.length>0){
						dyEditor.dialog.files({
							title:'系统提示',
							height:'550px',
							files:errFiles
						});
					}
					
					success && success(files);
				}
				break;
				
			default:
				uni.getImageInfo({	//只支持到<32768的宽高
				src	: file.path,
				fail:err=>{
					console.log('upload pano error:', err);
				},
				success	: res=>{
				//exif.getData(file, res=>{
						// console.log('exif:', exif.getAllTags(file));
						
						// let width	= exif.getTag(file, 'PixelXDimension');
						// let height	= exif.getTag(file, 'PixelYDimension');
						let width = res.width;
						let height = res.height;
						
						if(width / 2 != height){
							file.err = true;
							errFiles.push({
								name: file.name,
								text: '不是2:1全景图，无法上传',
							});
						//} else if(res.width > 16384){
						} else if(width > 32000){
							file.err = true;
							errFiles.push({
								name: file.name,
								text: '全景图超出3.2万像素边长的最大值，无法上传',
							});
						} else if(width < 1024){
							file.err = true;
							errFiles.push({
								name: file.name,
								text: '全景图小于1024像素边长的最小值，无法上传',
							});
						} else if(file.size > 120 * 1024 * 1024){
							file.err = true;
							errFiles.push({
								name: file.name,
								text: '全景图超出120MB的最大限制，无法上传',
							});
						} else if(i>=max){
							file.err = true;
							errFiles.push({
								name: file.name,
								text: '超出最大数量上限，无法上传',
							});
						}
						
						//检查完成
						if(idx++ >= files.length -1) {
							files = files.filter(item => {
								return !item.err;
							});
					
							if(errFiles.length>0){
								dyEditor.dialog.files({
									title:'系统提示',
									height:'550px',
									files:errFiles
								});
							}
							
							success && success(files);
						}
					}
				});
				break;
		}
	}
}

let time;

function upload({
	files, 
	item, 
	index, 
	success, 
	error,
	type,
}){
	let count 	= 0;
	let max 	= files.tempFiles.length;
	oldPanoId	= item ? item.id : null;
	
	dyConfig.needsUpdate = true;
	
	//检查文件是否合法
	checkFiles(files, files=>{
		resource.uploadFiles(config.data.id, files, {
			type : 'pano',
			ready : res=>{
				time = new Date().getTime();
				
				config.isUpdate = config.panoUpdate = true;
								
				let data;
				let result;
				let mode = null;
				switch(type){
					case 'pano':
						mode = 0;
						break;
					case 'fly':
						mode = 1;
						break;
					case 'normal':
						mode = 2;
						break;
				}
				if(!item) {
					result = dy3d.pano.add({id:res.id, name:res.name, size:res.size,type:'pano',mode:mode});
				} else {
					result = dy3d.pano.get(index);
					item.id		= res.id;
					item.status	= 0;
					item.size	= res.size;
					item.type 	= 'pano';
					item.mode 	= mode;
				}
				
				if(res.extName == 'mp4') result.video = true;
				
				if(type == 'fly'){
					result.offset.y = 100;
					//获取gps信息
					getExif(res.data, data=>{
						result.gps = data.gps;
						setOffsetFromGPS(result, data);
					});
				}
				
				return result;
			},
			success	: res=>{
				if(!dy3d.pano) return;
				
				let pano = dy3d.pano.get(res.item.id);
				
				res.item.status			= 1;
				res.item.progress		= 0;
				res.item.update_time	= parseInt(new Date().getTime() / 1000);
				res.type 				= 'pano';
				const panoId 			= res.item.id;
				res.item.brightness 	= pano.brightness || 1.0;
				res.item.saturation 	= pano.saturation || 1.1;
				res.item.contrast 		= pano.contrast	|| 1.1;
				
				oldPanoId && resetData(panoId);
				
				
				offsetOverlap(type);
				
				console.log('time3:', new Date().getTime() - time);
				
				if(++count >= max) {
					success && success(count, max);
				}
			},
			progress : res=>{
				res.item.progress = res.num;
			},
			error : res=>{
				dyEditor.toast.error('全景图上传失败！');
				res.item.status = 4;
				if(++count >= max) {
					success && success(count, max);
				}
			}
		});
	});
}

let preview = {
	project(id){
		return config.oss + '/vr/' + (id || config.data.id) + '/preview.jpg';
	},
	pano(id){
		//航拍下使用id而不是resourceId
		let projectId = config.data.resourceId;
		
		for(let i=0; i<config.data.panos.length;i++){
			let pano = config.data.panos[i];
			if(pano.id == id && pano.gps) projectId = config.data.id;
		}
		
		return config.oss + '/vr/' + projectId + '/tiles/' + id + '/preview.jpg';
	},
	default(){
		return '/static/pano.png';
	}
}

function getPanos(type){		//WF 稍后需要修改
	if(!config.data.panos || config.data.panos.length == 0) return [];
	
	return config.data.panos.filter((item,index,arr)=>{
		switch(type){
			case 'pano':
				return item.mode==0;
				
			case 'fly':			
				return item.mode==1;
				
			case 'normal':
				return item.mode==2;
			default:
				return item;
		}
	});
}

function offsetOverlap(type){
	let repeated	= false;
	//跟随提示文字展示重叠,当没有模型和模型重叠时,不显示全景的重叠图标,
	// let models = config.data.models;
	// if(models.length==0) return;
	// for(let i=0;i<models.length;i++){
	// 	if(models[i].repeated) return;
	// }
	if(type=='normal') return;
	let panos = getPanos(type);
	
	//GWL 2025.10.24重新实现  通过map查询可以提高100倍的性能
	const panoMap = new Map(panos.map((p,i)=> [p.offset.x+','+p.offset.y+','+p.offset.z, {idx:i, item:p}]));
	
	panos.forEach(v=>v.repeated=false);
	// console.time('offsetOverlap');
	panos.forEach((v,i)=>{
		const k = panoMap.get(v.offset.x+','+v.offset.y+','+v.offset.z);
							//隐藏模型纹理时不计算坐标重叠 
		if(k && k.idx>i && !k.item.noTexture){	
			repeated = v.repeated = k.item.repeated = true;
		}
		// if(!v.walk || v.noTexture) return;		
		// for(let j=i+1; j<panos.length; j++){
		// 	let k = panos[j];
		// 	if(v.offset.x == k.offset.x
		// 	&& v.offset.y == k.offset.y
		// 	&& v.offset.z == k.offset.z){
		// 		repeated = v.repeated = k.repeated = true;
		// 	}
		// }
	});
	// console.timeEnd('offsetOverlap');
	return repeated;
}

//重新上传全景时替换config相关旧的数据
function resetData(panoId){
	if(oldPanoId){
		//替换hotspots旧全景的ID
		const hotspots = dyConfig.data.hotspots;
		hotspots.forEach(v=>{
			if(v.target.panoId == oldPanoId) v.target.panoId = panoId;
			v.panoId.forEach((pid,idx)=>{
				if(pid == oldPanoId) {
					v.panoId[idx] = panoId;
				}
			})
		})
		
		//替换buttons旧全景的ID
		const buttons = dyConfig.data.buttons;
		buttons.forEach(v=>{
			if(v.panoId == oldPanoId) v.panoId = panoId;
			if(v.menu){
				v.children.forEach(c=>{
					if(c.panoId == oldPanoId) v.panoId = panoId;
				})
			}
		})
		
		//替换init旧全景的ID
		const fovData = dyConfig.data.init.fovData;
		if(fovData.pano.panoId == oldPanoId) fovData.pano.panoId = panoId;
		if(fovData.dolly.panoId == oldPanoId) fovData.dolly.panoId = panoId;
		if(fovData.fly.panoId == oldPanoId) fovData.fly.panoId = panoId;
		
		const switchMode = dyConfig.data.init.switchMode;
		if(switchMode.pano.panoId == oldPanoId) switchMode.pano.panoId = panoId;
		if(switchMode.fly.panoId == oldPanoId) switchMode.fly.panoId = panoId;
		
		//替换navigation旧全景ID
		const navigation = dyConfig.data.navigation;
		navigation.data.forEach(v=>{
			v.move.forEach(p=>{
				if(p.panoId == oldPanoId) p.panoId = panoId;
			})
		})
	}
}

//获取重复的编号
function repeatIndex(item, index, type){
	// let panos = getPanos(type);
	////GWL 不要在循环中多次使用下标遍历数组!
	// for(let i=0; i<panos.length; i++){
	// 	if(i!=index 
	// 		&& panos[i].type == item.type
	// 		&& panos[i].offset.x==item.offset.x 
	// 		&& panos[i].offset.y==item.offset.y 
	// 		&& panos[i].offset.z==item.offset.z){
	// 		return i;
	// 	}
	// }
	
	//数组有findIndex方法可以很方便的获取指定数据的下标
	return getPanos(type).findIndex((v,i)=>{
		return i!=index 
			&& v.offset.x == item.offset.x
			&& v.offset.y == item.offset.y
			&& v.offset.z == item.offset.z
	});
}

//获取重复的点位个数
function repeatCount(type){
	let panos = getPanos(type);
	let count = 0;
	
	for(let i=0; i<panos.length; i++){
		if(panos[i].repeated) count++;
	}
	
	return count;
}

// 返回全景点个数
function count(type) {
	return getPanos(type).length;
}

//是否有已完成的全景图
function hasPano(type) {
	let panos = getPanos(type);
	
	for(let i=0; i<panos.length; i++){
		if(panos[i].status == 3) return true;
	}
	
	return false;
}

//返回首个全景id，用来载入pano
function firstPano(type) {
	let panos = getPanos(type);
	if(panos.length >0) return panos[0];
}

function hasUpdate(pano){
	let ret = true;
	if(pano.gps){
		ret = pano.gps.lon != backupPano.gps.lon
			|| pano.gps.lat != backupPano.gps.lat
			|| pano.gps.alt != backupPano.gps.alt;
	}
	
	return ret && pano && backupPano &&
		( pano.id != backupPano.id
		|| pano.url != backupPano.url
		|| pano.name != backupPano.name
		|| pano.size != backupPano.size
		|| pano.walk != backupPano.walk
		|| pano.status != backupPano.status
		|| pano.update_time != backupPano.update_time
		|| pano.offset.x != backupPano.offset.x 
		|| pano.offset.y != backupPano.offset.y
		|| pano.offset.z != backupPano.offset.z
		|| pano.rotate.x != backupPano.rotate.x
		|| pano.rotate.y != backupPano.rotate.y
		|| pano.rotate.z != backupPano.rotate.z);
}


function backup(pano){
	//后续pano如果有新属性，要在这里补上
	backupPano = {
		id				: pano.id,
		url				: pano.url,
		name			: pano.name,
		originName		: pano.originName,
		size			: pano.size,
		walk			: pano.walk,
		floor			: pano.floor,
		status			: pano.status,
		height			: pano.height,
		images			: pano.images,
		levels			: pano.levels,
		loaded			: pano.loaded,
		update_time		: pano.update_time,
		fillColor		: pano.fillColor,
		mode			: pano.mode,
		repeated		: pano.repeated,
		type			: pano.type,
		////////////////////////////////////////////
		//WebGL使用的属性
		mesh			: pano.mesh,
		texture			: pano.texture,
		modelTexture	: pano.modelTexture,
		points			: pano.points,
		////////////////////////////////////////////
		offset			: {
			x : pano.offset.x,
			y : pano.offset.y,
			z : pano.offset.z,
		},
		rotate			: {
			x : pano.rotate.x,
			y : pano.rotate.y,
			z : pano.rotate.z,
		},
		saturation		: pano.saturation,
		brightness		: pano.brightness,
		contrast		: pano.contrast
	};
	
	if(pano.gps){
		backupPano.gps = {
			lon : pano.gps.lon,
			lat : pano.gps.lat,
			alt : pano.gps.alt,
		};
	}
	
	//因为pano对象中有webgl相关属性 无法做json序列化
	//backupPano = JSON.parse(JSON.stringify(pano));
}

function restore(item){
	for(let key in backupPano){
		item[key] = backupPano[key];
	}
	return item;
}

//获取没设置坐标的点位个数
function noGPSCount(){
	let panos = getPanos('fly');
	let count = 0;
	
	for(let i=0; i<panos.length; i++){
		let gps = panos[i].gps;
		if(gps.lon==0 && gps.lat==0) count++;
	}
	
	return count;
}

//相机坐标解析
function parseCamera(params, success, error){
	if(params.file.size > 1024 * 1024){
		return error && error('相机文件超出大小限制（1MB）');
	}
	
	const token			= dyEditor.getToken();
	const editorVersion	= window.appVersion;
	
	uni.uploadFile({
		name	: 'file',
		url		: dyConfig.api + '/toolkit/camera_parser',
		file	: params.file,
		header	: {
			token,
			editorVersion
		},
		timeout	: 60000, //上传文件超时时间为1分钟
		success	: (res) => success && success(res.data),
		fail	: (err) => error && error('发生错误！')
	});
}
function hadPano(id){
	let panos = getPanos();
	for(let i=0;i<panos.length;i++){
		if(panos[i].id==id){
			return true;
		}
	}
	return false;
}

function getBackup(){
	return backupPano;
}

function removeRefer(panoId){
	let panos = getPanos();
	
	for(let i=0; i<panos.length; i++){
		const pano = panos[i];
		if(pano.refer == panoId) delete pano.refer;
	}
}

export default {
	type :'pano',
	upload,
	preview,
	offsetOverlap,
	hasPano,
	hasUpdate,
	backup,
	restore,
	repeatIndex,
	repeatCount,
	count,
	firstPano,
	getPanos,
	noGPSCount,
	setOffsetFromGPS,
	getHeightFromGPS,
	parseCamera,
	hadPano,
	getBackup,
	removeRefer,
}